import './TextSeparator.css'

function TextSeparator () {
  return <div className="text-separator"></div>
}

export default TextSeparator
